function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "beamed-note");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 1l-0.002 13c0 1.243-1.301 3-3.748 3-1.243 0-2.25-0.653-2.25-1.875 0-1.589 1.445-2.55 3-2.55 0.432 0 0.754 0.059 1 0.123v-7.334l-7 1.273v9.363h-0.002c0 1.243-1.301 3-3.748 3-1.243 0-2.25-0.653-2.25-1.875 0-1.589 1.445-2.55 3-2.55 0.432 0 0.754 0.059 1 0.123v-11.698l11-2z"
});

var SvgBeamedNote = function SvgBeamedNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeamedNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beamed-note.32f7e825.svg";
export { ForwardRef as ReactComponent };